define('pushnami',[
    "jquery",
    "analytics",
    "logging"
], function ($, analytics, logging) {
    "use strict";

    var _ModuleName = "Pushnami Integration";
    var _config = {
        enabled: true,
        apiKeys: [
            {
                channel: "buddhist",
                key: "5d7278eb2c84920013fac1be"
            },
            {
                channel: "catholic",
                key: "5d72717e25408409ef3168df"
            },
            {
                channel: "contemplative",
                key: "5d7272fe59114c07c774f4c6"
            },
            {
                channel: "entertainment",
                key: "5d7272c701db63001263287a"
            },
            {
                channel: "evangelical",
                key: "5d7271c159114c07c774f295"
            },
            {
                channel: "family",
                key: "5d72720fa124d006d14052d2"
            },
            {
                channel: "general-christian",
                key: "5d72728c6991760012dc97b9"
            },
            {
                channel: "hindu",
                key: "5d7275dfb95ec700121376a6"
            },
            {
                channel: "jewish",
                key: "5d72786fe76a1c08c7200662"
            },
            {
                channel: "latter-day-saint",
                key: "5d72724734a5420012aa6ad2"
            },
            {
                channel: "muslim",
                key: "5d72755c2c84920013fabb73"
            },
            {
                channel: "new-visions",
                key: "5d7274cc2c9ea700129d567c"
            },
            {
                channel: "politics-blue",
                key: "5d727436b2e97a0012f1fe78"
            },
            {
                channel: "politics-red",
                key: "5d727333b2e97a0012f1fcd4"
            },
            {
                channel: "progressive-christian",
                key: "5d72707e2b9e9000129abbe5"
            },
            {
                channel: "pagan",
                key: "5d727138bfa36b0012fffc37"
            },
            {
                channel: "nonreligious",
                key: "5d726fbcddcec405ef3b40fb"
            },
            {
                channel: "faith-and-work",
                key: "5e0f4f2c0b816d00285dd775"
            },
            {
                channel: "more-voices",
                key: "5e0f50400b816d00285dd788"
            },
            {
                channel: "public-square",
                key: "5e0f50a662202c0012dce604"
            }
        ],
        defaultApiKey: "5d408247e93e9d16c92f341e",
        category: "Push Notifications",
        label: "Pushnami",
        events: [
            {
                PushnamiEventName: "permissions-action-subscribed-new",
                AnalyticsAction: "Accept"
            }
        ]
    };

    var init = function () {
        ;

        // grab channel and blog details off HTML
        var channel = $('html').data('content-channel');
        var blog = $('html').data('blog-name');
        var blogStatus = $('html').data('dormant-blog') ? 'dormant' : 'active';
        
        // Create options object with blog and channel details as available
        var options = {};
        if (blog) { options["blogURL"] = blog; }
        if (channel) { options["channel"] = channel; }
        options["active_status"] = blogStatus;

        // Get api key based on channel
        var apiKey = _getApiKey(channel);

        // If we got an API key, finish initializing. Otherwise, throw an error
        if(apiKey) {            
            ;
            ;
            ;

            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://api.pushnami.com/scripts/v1/pushnami-adv/" + apiKey;
            script.onload = function () {
                Pushnami
                    .update(options)
                    .prompt();

                // Hook into the defined events and fire analytics events
                for (var i = 0; i < _config.events.length; i++) {
                    var event = _config.events[i];
                    Pushnami.on([event.PushnamiEventName], function () {
                        analytics.FireEvent(_config.category, event.AnalyticsAction, _config.lable, true);
                    });
                }          
            };
            document.getElementsByTagName("head")[0].appendChild(script);
        } else {
            logging.error("Failed to find API Key for channel [" + (channel || 'not set') + "] and no default was configured. Unable to initialize Pushnami.", _ModuleName);
        }
    }

    var _getApiKey = function(channel) {
        for(var i = 0; i < _config.apiKeys.length; i++) {
            if (_config.apiKeys[i].channel == channel) {
                return _config.apiKeys[i].key;
            }
        }

        return '';
    }

    return {
        init: init
    }
});
